var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditableMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4171_4320)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.7578 1.76953L18.2305 2.24219C18.7188 2.73047 18.7188 3.52344 18.2305 4.01172L17.1875 5.05469L14.9453 2.8125L15.9883 1.76953C16.4766 1.28125 17.2695 1.28125 17.7578 1.76953ZM7.38281 10.375L14.0625 3.69531L16.3047 5.9375L9.625 12.6172C9.46094 12.7812 9.25 12.8984 9.02344 12.9531L6.46094 13.543L7.05078 10.9766C7.10156 10.75 7.21875 10.5391 7.38672 10.375H7.38281ZM15.1055 0.882812L6.5 9.49219C6.16797 9.82422 5.9375 10.2422 5.83203 10.6992L5.01562 14.2383C4.96875 14.4492 5.03125 14.668 5.18359 14.8203C5.33594 14.9727 5.55469 15.0352 5.76562 14.9883L9.30469 14.1719C9.76172 14.0664 10.1797 13.8359 10.5117 13.5039L19.1172 4.89453C20.0938 3.91797 20.0938 2.33594 19.1172 1.35938L18.6445 0.882812C17.668 -0.09375 16.0859 -0.09375 15.1094 0.882812H15.1055ZM3.125 2.5C1.39844 2.5 0 3.89844 0 5.625V16.875C0 18.6016 1.39844 20 3.125 20H14.375C16.1016 20 17.5 18.6016 17.5 16.875V11.875C17.5 11.5312 17.2188 11.25 16.875 11.25C16.5312 11.25 16.25 11.5312 16.25 11.875V16.875C16.25 17.9102 15.4102 18.75 14.375 18.75H3.125C2.08984 18.75 1.25 17.9102 1.25 16.875V5.625C1.25 4.58984 2.08984 3.75 3.125 3.75H8.125C8.46875 3.75 8.75 3.46875 8.75 3.125C8.75 2.78125 8.46875 2.5 8.125 2.5H3.125Z",
    fill: "#BDBDBD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4171_4320"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditableMessage);
export default __webpack_public_path__ + "static/media/editableMessage.21e88c62c1557949ab4c09f4f0641ca7.svg";
export { ForwardRef as ReactComponent };